export const APP_NAME = 'MP Plastic Industries'
export const APP_FULL_NAME = 'MP Plastic Industries'
export const APP_VERSION = '1.0.0'

export const STORAGE_KEYS = {
  AUTH_SESSION: 'pmms.auth.session',
  AUTH_TOKENS: 'pmms.auth.tokens',
  THEME: 'pmms.theme',
  SIDEBAR_COLLAPSED: 'pmms.sidebar.collapsed',
  BOOT_SPLASH: 'pmms.boot.splash',
  SALES_LEAD_LIST_FILTERS: 'pmms.sales.leads.list-filters',
  SALES_LEAD_LIST_COLUMNS: 'pmms.sales.leads.list-columns',
  SALES_LEAD_LIST_COLUMN_ORDER: 'pmms.sales.leads.list-column-order.v1',
  SALES_REGISTERED_LEAD_LIST_COLUMNS: 'pmms.sales.leads.registered-list-columns.v3',
  SALES_REGISTERED_LEAD_LIST_COLUMN_ORDER: 'pmms.sales.leads.registered-list-column-order.v1',
  TASK_LIST_COLUMNS: 'pmms.tasks.list-columns.v4',
  TASK_LIST_COLUMN_ORDER: 'pmms.tasks.list-column-order.v4',
  MESSENGER_FAB_POSITION: 'pmms.messenger.fab-position.v1',
  DASHBOARD_SALES_FILTERS: 'pmms.dashboard.sales-filters.v1',
  DASHBOARD_VIEW: 'pmms.dashboard.view.v1',
  /** Reports trend Day / Month / Quarter / Year — per user. */
  REPORTS_TREND_GRANULARITY: 'pmms.reports.trend-granularity.v1',
  /** Unsaved create-quotation form (survives refresh on the same prefill URL). */
  QUOTATION_CREATE_DRAFT: 'pmms.sales.quotation-create-draft.v1',
  /** Unsaved create-estimate form (same rule as quotations). */
  ESTIMATE_CREATE_DRAFT: 'pmms.sales.estimate-create-draft.v1',
} as const

/** Backend API base URL (env-driven) */
export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:5600/api/v1'

export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100] as const
export const DEFAULT_PAGE_SIZE = 10

/** Reference-data dropdowns (partners, categories, etc.) — longer cache. */
export const SELECT_LOOKUP_STALE_TIME = 5 * 60_000

/** Transaction document lists (dispatches, purchases). */
export const DOCUMENT_LIST_STALE_TIME = 30_000

/** Single dispatch / purchase sheet detail. */
export const DOCUMENT_DETAIL_STALE_TIME = 60_000

/** Report catalog (export types list). */
export const REPORT_CATALOG_STALE_TIME = 5 * 60_000

/** Summary JSON (overview / breakdowns / trend). */
export const REPORT_SUMMARY_STALE_TIME = 30_000

/** Dashboard's own Sales summary reads (useSalesWidget) — an overview glance
 * can tolerate staler data than Reports' own active-filtering UX, so this is
 * deliberately longer than REPORT_SUMMARY_STALE_TIME rather than bumping
 * that shared constant (which would also slow Reports' own refetch cadence). */
export const DASHBOARD_SALES_STALE_TIME = 3 * 60_000
